// DEPRECATED: Use CommonButtons from src/shared/components/CommonButtons instead.
// This component reads theme from sessionStorage directly and uses an untyped Buttondata prop.
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
interface Props {
  Buttondata: any | undefined;
  disabled?: boolean;
  onClick?: () => void;
}
const Buttons: React.FC<Props> = ({ Buttondata, disabled = false, onClick }) => {
  const [background, setbackground] = useState<any>("");
  const [fontcolor, setfontcolor] = useState<any>("");
  const [fontfamily, setfontfamily] = useState<any>("");
  useEffect(() => {
    const bussness = sessionStorage.getItem("organization_name")
    const storedColor = sessionStorage.getItem(`background_color${bussness}`);
    const fontcolor = sessionStorage.getItem(`font_color${bussness}`);
    const fontfamily = sessionStorage.getItem(`font_family${bussness}`);
    if (storedColor) { setbackground(storedColor); }
    if (fontcolor) { setfontcolor(fontcolor); }
    if (fontfamily) { setfontfamily(fontfamily); }
  }, [])
  
  return (
    <div>
      {Buttondata?.Cancel && (
        <Button
          disabled={disabled}
          onClick={onClick}
          style={{
            background: "none",
            border: `2px solid ${background}`,
            borderRadius: "40px",
            height: "40px",
            width: "190px",
            color: background,
            fontSize: "large",
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          <span style={{ fontFamily: fontfamily, fontSize: "large", }}>{Buttondata?.name}</span>
        </Button>
      )}

      {Buttondata?.Confirm && (
        <Button
          disabled={disabled}
          onClick={onClick}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: disabled ? "#CDBDD3" : background,
            borderRadius: "40px",
            height: "40px",
            width: "auto",
            color: fontcolor,
            fontSize: "large",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          <span style={{ fontFamily: fontfamily, fontSize: "large" }}>{Buttondata?.name}</span>
        </Button>
      )}
      {Buttondata?.Blue && (
        <Button
          disabled={disabled}
          onClick={onClick}
          style={{
            backgroundColor: disabled ? "#CDBDD3" : background,
            borderRadius: "40px",
            height: "40px",
            width: "auto",
            minWidth: "190px",
            color: fontcolor,
            fontWeight: "bold",
            fontSize: "large",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          <span style={{ fontFamily: fontfamily, fontSize: "large" }}>{Buttondata?.name}</span>
        </Button>
      )}
      {Buttondata?.error && (
        <Button
          disabled
          onClick={onClick}
          style={{
            backgroundColor: "#CDBDD3",
            borderRadius: "40px",
            borderWidth: "2px",
            height: "40px",
            width: "190px",
            color: "white",
            fontSize: "large",
            cursor: "not-allowed",
            animation: "normal",
            fontFamily: fontfamily,
          }}
        >
          <span style={{ fontFamily: fontfamily, fontSize: "large" }}>{Buttondata?.name}</span>
        </Button>
      )}
      {Buttondata?.nsuccess && (
        <button
          disabled={disabled}
          onClick={onClick}
          style={{
            fontFamily: fontfamily,
            backgroundColor: disabled ? "#CDBDD3" : background,
            borderRadius: "40px",
            padding: '2px 20px',
            color: fontcolor,
            borderColor: background,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.6 : 1,
          }}
        >
          <span style={{ fontFamily: fontfamily, fontSize: "large" }}>{Buttondata?.name}</span>
        </button>
      )}
      {Buttondata?.ncancel && (
        <button
          disabled={disabled}
          onClick={onClick}
          style={{
            fontFamily: fontfamily,
            background: 'none',
            borderRadius: "40px",
            padding: '2px 20px',
            color: disabled ? "#CDBDD3" : background,
            borderColor: disabled ? "#CDBDD3" : background,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.6 : 1,
          }}
        >
          <span style={{ fontFamily: fontfamily, fontSize: "large" }}>{Buttondata?.name}</span>
        </button>
      )}
    </div>
  );
};

export default Buttons;